import { Button, Grid, Icon } from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';
import PermissionHide from 'components/PermissionHide';
import React, { memo, useCallback, useEffect } from 'react';
import { toast } from 'react-toastify';
import whitelistService from 'v2/services/whitelist';

import CreateAndEdit from './CreateAndEdit';
import Filter from './Filter';
import List from './List';

const useStyle = makeStyles((theme) => ({
  header: {
    marginBottom: 16,
  },
  title: {
    flex: '1',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: '#192542',
    '& h1': {
      fontSize: '2rem',
      lineHeight: 1,
      fontWeight: 400,
      marginBottom: '0.5rem',
    },
    '& p': {
      fontSize: '1rem',
      lineHeight: '1.3125rem',
      color: '#818b9d',
    },
    [theme.breakpoints.down('xs')]: {
      flex: 'unset',
    },
  },
  reports: {
    flex: 'flex',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      marginTop: theme.spacing(2),
    },
  },
}));

const WhiteList = () => {
  const classes = useStyle();
  useEffect(() => {
    whitelistService.loadWhiteLists().subscribe(() => {}, toast.error);
  }, []);

  const newWhiteList = useCallback(() => {
    whitelistService.setCurrentWhiteList(null);
    whitelistService.setCreateAndEditDialog(true);
  }, []);

  useEffect(() => {
    return () => whitelistService.cleanFilter();
  }, []);

  return (
    <>
      <Grid container justify='space-between' alignItems='flex-start' className={classes.header}>
        <div className={classes.title}>
          <h1>Recompra (Whitelist)</h1>
          <p>Gerencie clientes que podem comprar várias vezes com o mesmo CPF/CNPJ.</p>
        </div>
        <PermissionHide action='myeduzz:whitelist:editar'>
          <div className={classes.reports}>
            <Button color='secondary' variant='contained' startIcon={<Icon>add</Icon>} onClick={newWhiteList} fullWidth>
              Adicionar cliente
            </Button>
          </div>
        </PermissionHide>
      </Grid>
      <CreateAndEdit />
      <Filter />
      <List />
    </>
  );
};

export default memo(WhiteList);
